"use strict";

jQuery(function () {
  var selectors = {
    navItem: ".omb-benefits-features__nav-item",
    tabItem: ".omb-benefits-features__card"
  };
  var classes = {
    active: "active"
  };

  $(selectors.navItem).on('click', function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $(selectors.navItem).removeClass('active');
    $(this).addClass(classes.active);
    $(selectors.tabItem).removeClass('active');
    $(target).addClass(classes.active);
  });
});
'use strict';

jQuery(function () {
  var selectors = {
    probioticCerts: "[data-product-probiotic-certs]"
  };

  var renderData = function renderData() {
    var $probioticCerts = $(selectors.probioticCerts);

    if (theme.probioticCerts && theme.probioticCerts.length && $probioticCerts.length) {
      var metafieldData = $probioticCerts.attr('data-product-probiotic-certs').split('\n');
      var itemsData = theme.probioticCerts.filter(function (item) {
        return metafieldData.includes(item.heading);
      });
      var content = '';

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = itemsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var image = item.image,
              heading = item.heading,
              description = item.description;


          content += '\n          <div class="col">\n            <div class="omb-certs__item">\n              <header class="omb-certs__item-header">\n                <figure class="omb-certs__item-figure">\n                  <img class="lazyload" src="' + image.src + '" alt="' + image.alt + '">\n                </figure>\n                <h4 class="h6 mb-0">' + heading + '</h4>\n              </header>\n              <div class="omb-certs__item-description">' + description + '</div>\n            </div>\n          </div>\n        ';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $(selectors.probioticCerts).append(content);
    }
  };

  var init = function init() {
    renderData();
  };

  init();
});
'use strict';

jQuery(function () {
  var selectors = {
    probioticClinicalSupport: "[data-product-probiotic-clinical-support]"
  };

  var renderData = function renderData() {
    var $probioticClinicalSupport = $(selectors.probioticClinicalSupport);

    if (theme.probioticClinicalSupport && theme.probioticClinicalSupport.length && $probioticClinicalSupport.length) {
      var metafieldData = $probioticClinicalSupport.attr('data-product-probiotic-clinical-support').split(', ');
      var itemsData = theme.probioticClinicalSupport.filter(function (item) {
        return metafieldData.includes(item.id);
      });
      var content = '';

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = itemsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var url = item.url,
              heading = item.heading,
              authorImage = item.authorImage,
              authorName = item.authorName;


          content += '\n          <div class="col">\n            <article class="omb-clinical-support__item">\n              <a class="omb-clinical-support__item-link" href="' + url + '" target="_blank" rel="noreferrer"></a>\n              <h4 class="omb-clinical-support__item-heading mb-0"><strong>' + heading + '</strong></h4>\n              <footer>\n                <figure class="omb-clinical-support__item-figure">\n                  <img class="lazyload" src="' + authorImage.src + '" alt="' + authorImage.alt + '">\n                </figure>\n                <p class="mb-0">' + authorName + '</p>\n              </footer>\n            </article>\n          </div>\n        ';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $(selectors.probioticClinicalSupport).append(content);
    }
  };

  var init = function init() {
    renderData();
  };

  init();
});
'use strict';

jQuery(function () {
  var selectors = {
    probioticIcons: "[data-product-probiotic-icons]"
  };

  var renderIcons = function renderIcons() {
    var $probioticIcons = $(selectors.probioticIcons);

    if (theme.probioticIcons && theme.probioticIcons.length && $probioticIcons.length) {
      var metafieldData = $probioticIcons.data('product-probiotic-icons').split(', ');
      var itemsData = theme.probioticIcons.filter(function (item) {
        return metafieldData.includes(item.heading);
      });
      var content = '';

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = itemsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var image = item.image,
              heading = item.heading;


          content += '<div class="col"><div class="omb-kit-intro__item">';
          if (item.image.aspectRatio) {
            content += '\n            <figure class="omb-kit-intro__figure">\n              <img class="omb-kit-intro__image lazyload"\n                    data-src="' + image.src + '"\n                    data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"\n                    data-aspectratio="' + image.aspectRatio + '"\n                    data-sizes="auto"\n                    alt="' + image.alt + '">\n            </figure>\n          ';
          } else {
            content += '\n            <figure class="omb-kit-intro__figure">\n              <img class="omb-kit-intro__image" loading="lazy" lazyloaded src="' + image.src + '" alt="">\n            </figure>\n          ';
          }
          content += '<div class="omb-kit-intro__text-content"><h4 class="h6">' + heading + '</h4></div></div></div>';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $(selectors.probioticIcons).append(content);
    }
  };

  var init = function init() {
    renderIcons();
  };

  init();
});
'use strict';

jQuery(function () {
  var selectors = {
    probioticStrains: "[data-product-probiotic-strains]"
  };

  var renderStrains = function renderStrains() {
    var $probioticStrains = $(selectors.probioticStrains);
    var iconCheck = '\n      <svg version="1.1" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">\n        <path fill="none" d="M0,0h24v24H0V0z"></path>\n        <path d="M9,16.17L4.83,12l-1.42,1.41L9,19L21,7l-1.41-1.41L9,16.17z"></path>\n      </svg>\n    ';

    if (theme.probioticStrains && theme.probioticStrains.length && $probioticStrains.length) {
      var metafieldData = $probioticStrains.data('product-probiotic-strains').split(', ');
      var itemsData = theme.probioticStrains.filter(function (item) {
        return metafieldData.includes(item.code);
      });
      var content = '';

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = itemsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var description = item.description,
              code = item.code;


          content += '\n          <li class="d-flex align-items-baseline">\n            <span class="omb-check omb-check-orange">\n              ' + iconCheck + '\n            </span>\n            <p>' + description + ' <span>(' + code + ')</span></p>\n          </li>\n        ';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $(selectors.probioticStrains).append(content);
    }
  };

  var init = function init() {
    renderStrains();
  };

  init();
});

"use strict";